import React from "react";

import svg from "../../assets/images/icons/collapse.svg";

export const CollapseIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Collapse"}
    />
);
